<template>
  <div v-if="data">
    <div v-for="(proxy, index) in data" :key="proxy + index">
      <div class="form-base__title preview break">
        {{ `Доверенность №${proxy.proxyInfo.number}` }}
      </div>

      <div class="form-base__title preview break">Сведения о доверенности</div>
      <div class="break section-block row-box">
        <WrapperField
          v-for="(fieldValue, fieldName) in proxy.proxyInfo"
          :key="fieldValue + fieldName"
          :data="
            createDataField({
              fieldName,
              fieldValue,
              fieldGroup: FieldGroup.PROXY_INFO,
            })
          "
        ></WrapperField>
      </div>

      <div class="form-base__title preview break">Сведения о доверителях</div>
      <div
        v-for="proxyTrustee in proxy.trusties"
        :key="`proxyTrustee${proxyTrustee.number}`"
      >
        <div class="form-base__title preview break">
          {{ `Доверитель №${proxyTrustee.number}` }}
        </div>
        <div class="row-box mb-5">
          <Person :data="proxyTrustee" v-if="proxyTrustee.person" />
          <WrapperField
            v-for="(fieldValue, fieldName) in proxyTrustee.identityDocument"
            :key="fieldValue + fieldName"
            :data="
              createDataField({
                fieldName,
                fieldValue,
                fieldGroup: FieldGroup.IDENTITY_DOCUMENT,
              })
            "
          ></WrapperField>

          <Organization :data="proxyTrustee" v-if="proxyTrustee.organization" />

          <ForeignOrganization
            :data="proxyTrustee"
            v-if="proxyTrustee.foreignOrganization"
          />
        </div>
      </div>

      <div class="form-base__title preview break">
        Сведения о доверенных лицах
      </div>
      <div
        v-for="proxyPerson in proxy.proxyPersons"
        :key="`proxyPerson${proxyPerson.number}`"
      >
        <div class="form-base__title preview break">
          {{ `Доверенное лицо №${proxyPerson.number}` }}
        </div>
        <div class="row-box mb-5">
          <WrapperField
            v-for="(fieldValue, fieldName) in proxyPerson.person"
            :key="fieldValue + fieldName"
            :data="
              createDataField({
                fieldName,
                fieldValue,
                fieldGroup: FieldGroup.PROXY_PERSON,
              })
            "
          ></WrapperField>
          <WrapperField
            v-for="(fieldValue, fieldName) in proxyPerson.identityDocument"
            :key="fieldValue + fieldName"
            :data="
              createDataField({
                fieldName,
                fieldValue,
                fieldGroup: FieldGroup.IDENTITY_DOCUMENT_SHORT,
              })
            "
          ></WrapperField>

          <Organization :data="proxyPerson" v-if="proxyPerson.organization" />

          <ForeignOrganization
            :data="proxyPerson"
            v-if="proxyPerson.foreignOrganization"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import Person from '@/components/elements/statement/FullStatementView/elements/Person';
import Organization from '@/components/elements/statement/FullStatementView/elements/Organization';
import ForeignOrganization from '@/components/elements/statement/FullStatementView/elements/ForeignOrganization';

export default {
  name: 'Step2',
  components: {
    WrapperField,
    ForeignOrganization,
    Organization,
    Person,
  },
  props: ['data'],
  data: () => ({
    createDataField,
    FieldGroup,
  }),
};
</script>
